import { FORMAT_TEXT_COMMAND } from "lexical";
import React from "react";
import { FormatProps, toolTipConstants } from "../../LexicalEditor/LexicalEditor.types";
import { BoldIcon } from "../../../assets/icons/SvgIcons";

const Bold = ({ editor, active, isDropdown, readOnly }: FormatProps) => {
  return (
    <button
      type="button"
      title={toolTipConstants.bold}
      onClick={() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold");
      }}
      className={`lexical-toolbarItem ${active ? "lexical-itemActive" : ""} ${
        isDropdown ? "lexical-toolbarItem2" : ""
      }`}
      aria-label="Format Bold"
      disabled={readOnly}
    >
      <div className="lexical-shortcutWrapper">
        <BoldIcon />
        {isDropdown && <span className="lexical-shortcutText">Bold</span>}
      </div>
      {isDropdown && <span className="lexical-shortcut">Ctrl+B</span>}
    </button>
  );
};

export default Bold;
